import { gql } from "@apollo/client";

export const GET_ANSWERS = gql`
  query getAnswers($patientId: Int!) {
    answers(user_app_id: $patientId) {
      id
      content
    }
  }
`;
